import { DateHelpers } from '@shared/helpers';

export const toDisplayDate = (date: string | undefined | null) =>
    date ? DateHelpers.dateFormatter({ date, format: 'DD.MM.YYYY' }) : '';
